import axios from 'axios';

export const getConsolidatedInventorySources = async () => {
  const response = await axios.get('/consolidatedInventory/config');
  return response?.data ?? [];
};

export const postExcludedInventorySources = async (excludedSourceIds) => {
  const response = await axios.post('/consolidatedInventory/config', excludedSourceIds);
  return response?.data ?? [];
};

export const getConsolidatedInventoryConnections = async () => {
  const response = await axios.get('/consolidatedInventory/connections');
  return response?.data ?? [];
};

export const updateConsolidatedInventoryConnectionTerminusType = async (connectionId, terminusType) => {
  const response = await axios.post(`/consolidatedInventory/connections/${connectionId}/terminusType`, { terminusType });
  return response?.data ?? [];
};

export const bulkUpdateConnections = async (updateConnectionRequests) => {
  const response = await axios.post('/consolidatedInventory/connections/update', {
    updateConnectionRequests,
  });
  return response?.data ?? [];
};

export const syncConsolidatedInventoryCounts = async () => {
  const response = await axios.post('/consolidatedInventory/inventory/sync');
  return response;
};

export const setAutomaticSync = async (shouldAutoSync) => {
  await axios.post('/consolidatedInventory/setAutomaticSync', shouldAutoSync);
};

export const getInventorySources = async (includeAllOption = true) => {
  const response = await axios.get(`/inventorysources?includeAllOption=${includeAllOption ? 'true' : 'false'}`);
  return response?.data ?? [];
};
